var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertifiedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70476 0L13.2174 3.84836L6.70535 7.69638L0.192735 3.84802L6.70476 0ZM6.90102 8.03531L13.4095 4.18938V12.1905L6.90102 15.8885V8.03531ZM6.70452 15.9998H6.70503L6.70476 16L6.70452 15.9998ZM6.50968 8.03531V15.8759L0 11.7333V4.18869L6.50968 8.03531ZM0.000760696 3.96146L0 3.96274V3.96191L0.000760696 3.96146ZM1.97946 3.91618L3.11001 4.61663L7.87299 1.65014L6.74245 0.949691L1.97946 3.91618ZM4.88865 5.75986L3.75811 5.05941L8.52109 2.09292L9.65164 2.79337L4.88865 5.75986ZM5.61358 6.23714L6.74412 6.9376L11.5071 3.97111L10.3766 3.27065L5.61358 6.23714Z",
    fill: "url(#paint0_linear_1030_12187)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1030_12187",
    x1: 6.70476,
    y1: 1.48703,
    x2: 6.70476,
    y2: 15.8501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC9866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994616,
    stopColor: "#792E8E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertifiedCheck);
export default __webpack_public_path__ + "static/media/certifiedCheck.fd3d00c0e6c20343c159ff018ad7fa95.svg";
export { ForwardRef as ReactComponent };